export default "__VITE_ASSET__ByspSOur__"